// Copyright (c) 2022 by Move Closer

import { IRelatedService, ModuleContentResolver, ProductData } from '../../contexts'
import { logger } from '../../support'

import { resolveProduct } from '../resolvers'

import { ProductHeaderModuleContent, ProductHeaderModuleContentInput } from './ProductHeader.contracts'

/**
 * @author Katarzyna Otto <katarzyna.otto@movecloser.pl> (original)
 * @author Javlon Khalimjonov <javon.khalimjonov@movecloser.pl> (edited)
 */
export const resolveProductHeaderModuleContent: ModuleContentResolver<ProductHeaderModuleContentInput, ProductHeaderModuleContent> =
  async (
    input: ProductHeaderModuleContentInput,
    relatedService: IRelatedService
  ): Promise<ProductHeaderModuleContent> => {
    let product: ProductData | null = null

    if (input.product) {
      try {
        product = await resolveProduct(input.product, relatedService)
      } catch (e) {
        logger(e, 'warn')
      }
    }

    return {
      ...input,
      product
    }
  }
